import { Spaces } from '@mail/cross-sizes-utils';

export const RETRY_TIMEOUT_CONNECTION_ERROR = 10 * 1000;
export const RETRY_TIMEOUT_ERROR_FILE_SKIP = 1000;
export const BIG_FILE_SZIE = 100 * Spaces.ONE_MB;
export const DEFAULT_FILE_UPLOAD_SPEED = 8; // Mb/sec
